import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Hourglass, SignOut, List, X } from "@phosphor-icons/react";
import { useState } from "react";

const navItems = [
  { to: "/dashboard", label: "Dossier", code: "01" },
  { to: "/calculator", label: "Vita-Engine", code: "02" },
  { to: "/scenarios", label: "Scénarios", code: "03" },
  { to: "/documents", label: "Vita-Parser", code: "04" },
  { to: "/reports", label: "Vita-Writer", code: "05" },
  { to: "/judgment", label: "Jugement", code: "06" },
  { to: "/observatory", label: "Observatory", code: "07" },
  { to: "/profile", label: "Vita-Mea", code: "08" },
  { to: "/apprentissage", label: "Apprendre", code: "09" },
];

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); nav("/"); };

  return (
    <header className="border-b border-black bg-[var(--paper)] sticky top-0 z-30" data-testid="app-header">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-3" data-testid="header-logo">
            <Hourglass weight="fill" size={26} className="text-[var(--signal)]" />
            <div>
              <div className="font-serif text-xl font-semibold leading-none tracking-tight">VITA-LEX</div>
              <div className="label-mono text-[9px] mt-0.5">ANALYTICA · DOSSIER N°001</div>
            </div>
          </Link>

          {user && (
            <nav className="hidden lg:flex items-center gap-1">
              {navItems.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  data-testid={`nav-${it.to.slice(1)}`}
                  className={({ isActive }) =>
                    `px-3 py-2 label-mono hover:text-[var(--ink)] transition-colors flex items-center gap-2 ${
                      isActive ? "text-[var(--signal)]" : "text-[var(--muted)]"
                    }`
                  }
                >
                  <span className="opacity-50">{it.code}</span>
                  <span>{it.label}</span>
                </NavLink>
              ))}
            </nav>
          )}

          <div className="flex items-center gap-3">
            {user ? (
              <>
                <div className="hidden md:block text-right">
                  <div className="text-xs font-mono text-[var(--muted)]">CITOYEN</div>
                  <div className="text-sm font-medium" data-testid="header-user-name">{user.nom_complet}</div>
                </div>
                <button onClick={handleLogout} className="border border-black px-3 py-2 hover:bg-black hover:text-[var(--paper)] transition-colors flex items-center gap-2" data-testid="header-logout">
                  <SignOut size={16} />
                  <span className="label-mono hidden sm:inline">Sortir</span>
                </button>
                <button onClick={() => setOpen(!open)} className="lg:hidden border border-black p-2" data-testid="header-menu-toggle">
                  {open ? <X size={18} /> : <List size={18} />}
                </button>
              </>
            ) : (
              <Link to="/auth" data-testid="header-cta-auth" className="bg-[var(--signal)] hover:bg-[var(--signal-hover)] text-[var(--paper)] px-4 py-2 label-mono">
                Souveraineté →
              </Link>
            )}
          </div>
        </div>

        {user && open && (
          <div className="lg:hidden border-t border-black/10 py-3 grid grid-cols-2 gap-1">
            {navItems.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 label-mono border border-black/10 ${isActive ? "bg-black text-[var(--paper)]" : ""}`
                }
              >
                {it.code} · {it.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
